import styled from "styled-components";

const Container = styled.div`
  padding: 0;
  position: relative;

  h3 {
    font-size: 20px;
    margin: 0;
  }

  .grid-app-header {
    color: white;
    background-color: #555;
    height: 40px;
  }

  .subheader-container {
    position: relative;
  }

  .MuiDataGrid-columnHeaderTitleContainer {
    color: white;
    background-color: #555;
    height: 40px;
    overflow: hidden;
  }

  .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-sortIcon {
    color: white;
  }

  .MuiDataGrid-menuIcon > button > svg {
    color: white;
  }

  .MuiDataGrid-columnHeaderTitleContainerContent
    > .MuiCheckbox-root
    > .MuiSvgIcon-root {
    color: rgba(255, 255, 255, 0.7);
    &:hover {
      color: white;
    }
  }

  .MuiButton-root.filter {
    margin: 15px 0;
    width: 130px;
  }

  .MuiOutlinedInput-root.search {
    position: absolute;
    right: 0;
    top: 58px;
    height: 35px;
  }

  .MuiOutlinedInput-root.MuiInputBase-root.filter {
    width: 100%;
    height: 50px;
  }

  .MuiTextField-root.notice-date-ranges {
    position: absolute;
    right: 0;
    top: 120px;
  }

  .MuiTextField-root.notice-date-ranges.home {
    top: 35px;
  }

  .MuiTextField-root.notice-date-ranges .MuiOutlinedInput-root {
    width: 170px;
    height: 35px;
  }
`;

const TableContainer = styled.div`
  width: 100%;
`;

export { Container, TableContainer };
